import { GenericDrawer, useGoatImage } from '@capsicum/common-web';
import { type NCWSendErrorDrawerProps, useNCWSendErrorDrawer } from '@capsicum/features/nc-wallet/shared';

/**
 * This error drawer shows at the end of the NCW Send flow in case of errors and exceptions
 * @param {() => void} onPrimaryButtonActivate The callback for the primary button
 * @param {() => void} onSecondaryButtonActivate The callback for the second button
 */
export const NCWSendErrorDrawer = ({ onPrimaryButtonActivate, onSecondaryButtonActivate }: NCWSendErrorDrawerProps) => {
	const { intlText } = useNCWSendErrorDrawer();
	const goatAlert = useGoatImage('alert');

	return (
		<GenericDrawer
			buttonText={intlText.tryAgainButtonText}
			description={intlText.description}
			image={goatAlert}
			isButtonFullWidth={false}
			isButtonOnRow={false}
			secondaryActionButtonText={intlText.contactSupport}
			testID="ncw-send-error-modal"
			title={intlText.title}
			onButtonPress={onPrimaryButtonActivate}
			onSecondaryActionOnButtonPress={onSecondaryButtonActivate}
		/>
	);
};
